<div class="w-full py-3 px-4">
  <div class="sm:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <!-- Back Button SVG (clickable) -->
    <svg class="size-6 cursor-pointer" [routerLink]="['/product-creation']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
    
        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
            <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
    </svg>
      <img
        class="size-6 sm:size-8 lg:size-10"
        src="/assets/images/stock/check-list.png"
        alt="Report"
      />
      <span class="capitalize font-semibold text-sm sm:text-base lg:text-xl text-444"
        >Material Requirement Sheet (MRS)</span
      >
    </div>
  </div>

  <div class="w-full py-4 bg-[#FFFFF6] rounded-md">
     <div class="w-full lg:w-2/3 mx-auto px-3 grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-2.5 lg:gap-3 space-y-0.5">

        <div class="col-span-1">
          <app-custom-select label="Select Product" [options]="productType" formControlName="" [(selected)]="selectedProduct"
            selectId="productType">
          </app-custom-select>
        </div>
<!--
        <div class="col-span-1">
          <app-custom-select label="" [options]="prodType" formControlName="" [(selected)]="selectedProd"
            selectId="prodType">
          </app-custom-select>
        </div> -->

        <div class="col-span-1">
           <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Qty</label>
          </div>
        </div>

         <div class="col-span-1">
        <div class="h-full flex items-center justify-end gap-3">
          <p class="flex items-center gap-1 text-sm lg:text-lg text-[#0BB60B] font-medium">
            <svg class="cursor-pointer size-6 lg:size-10" fill="#0BB60B" viewBox="0 0 56.00 56.00"
              xmlns="http://www.w3.org/2000/svg" stroke="#0BB60B">
              <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(9.52,9.52), scale(0.66)">
                <rect x="0" y="0" width="56.00" height="56.00" rx="0" fill="#ffffff" strokewidth="0"></rect>
              </g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M 13.7851 49.5742 L 42.2382 49.5742 C 47.1366 49.5742 49.5743 47.1367 49.5743 42.3086 L 49.5743 13.6914 C 49.5743 8.8633 47.1366 6.4258 42.2382 6.4258 L 13.7851 6.4258 C 8.9101 6.4258 6.4257 8.8398 6.4257 13.6914 L 6.4257 42.3086 C 6.4257 47.1602 8.9101 49.5742 13.7851 49.5742 Z M 27.9882 39.6367 C 26.6523 39.6367 25.9492 38.6758 25.9492 37.3164 L 25.9492 30.0274 L 18.2617 30.0274 C 16.8788 30.0274 15.9179 29.3008 15.9179 28.0118 C 15.9179 26.6758 16.8320 25.9258 18.2617 25.9258 L 25.9492 25.9258 L 25.9492 18.1680 C 25.9492 16.8086 26.6523 15.8477 27.9882 15.8477 C 29.2773 15.8477 30.0742 16.7617 30.0742 18.1680 L 30.0742 25.9258 L 37.7851 25.9258 C 39.2148 25.9258 40.1054 26.6758 40.1054 28.0118 C 40.1054 29.3008 39.1679 30.0274 37.7851 30.0274 L 30.0742 30.0274 L 30.0742 37.3164 C 30.0742 38.7227 29.2773 39.6367 27.9882 39.6367 Z">
                </path>
              </g>
            </svg> Add
          </p>

          <p class="flex items-center gap-1 text-sm lg:text-lg text-[#BB0000] font-medium">
            <svg class="cursor-pointer size-5 lg:size-8" viewBox="0 0 30 31" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect y="0.5" width="30" height="30" rx="5" fill="#BB0000" />
              <path
                d="M7.06189 17C7.02104 16.6724 7 16.3387 7 16C7 11.5817 10.5817 8 15 8C17.5006 8 19.7332 9.14727 21.2002 10.9442M21.2002 10.9442V8M21.2002 10.9442V10.9999L18.2002 11M22.9381 15C22.979 15.3276 23 15.6613 23 16C23 20.4183 19.4183 24 15 24C12.6106 24 10.4659 22.9525 9 21.2916M9 21.2916V21H12M9 21.2916V24"
                stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg> Clear
          </p>
        </div>
      </div>

      </div>
  </div>

  <div class=" lg:w-2/3 mx-auto sm:flex items-center justify-between my-4">
  <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Material Requirement Sheet</span>
</div>
  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
  <table
    class="w-full lg:w-2/3 mx-auto table border border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden">
    <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
      <tr class="bg-gray-100">
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Sr. No.</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Date</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Product Type</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Product Code</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Required</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Available</th>
        <th class="p-3 font-medium border-r border-444 last:border-r-0 border-b-0">Shortage</th>
      </tr>
    </thead>
    <tbody>
      <tr class="text-xs sm:text-sm lg:text-[15px]">
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">1</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">25-04-2025</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">Wholesale</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
      </tr>
      <tr class="text-xs sm:text-sm lg:text-[15px]">
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">2</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">25-04-2025</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">Wholesale</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
      </tr>
      <tr class="text-xs sm:text-sm lg:text-[15px]">
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">3</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">25-04-2025</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0">Wholesale</td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
        <td class="py-1 px-2 text-center border border-[#d9d9dd] border-l-0 border-b-0"></td>
      </tr>

  </table>

</div>

</div>
